import PropTypes from 'prop-types';

import Link from 'core/components/Link';
import Image from 'core/components/Image';

export default function ReleaseImage(props) {
  const {
    url,
    imageSrc,
    parentProps,
  } = props;

  const {
    isMobile,
  } = parentProps;

  return (
    <Link
      to={url}
      type='blank'
      followExternal
    >
      <Image
        src={imageSrc}
        width={isMobile ? 150 : 180}
        height={isMobile ? 75 : 90}
        webdavHost='quto.ru'
        thumborHost='https://quto.ru/thumb'
      />
    </Link>
  );
}

ReleaseImage.propTypes = {
  url: PropTypes.string,
  imageSrc: PropTypes.object,
  parentProps: PropTypes.object,
};
